import {useState} from 'react'

const StatementItem = ({item,index}) => {

    const [copyId,setCopyId] = useState();

    const copyTracking = (trackingNo,trackingId,e)=>{
        e.preventDefault();
        e.stopPropagation();
        navigator.clipboard.writeText(trackingNo);
        setCopyId(trackingId)
        setTimeout(() => setCopyId(null), 2000);
    }

  return (
    <>
    <div
        key={item.tracking_id}
        className="accordion-item border-0 shadow-sm rounded-4 mb-3 overflow-hidden"
        >
        <h2 className="accordion-header">
            <button
            className="accordion-button collapsed bg-secondary shadow-none py-3 ps-3"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target={`#tracking${item.tracking_id}`}
            >
            <div className="row w-100 pe-3">
                <div className="col-6 col-lg-4">
                <small className="text-dark d-block">Tracking</small>
                <strong className="text-dark" style={{userSelect:'text',cursor:'text'}} onClick={(e)=> copyTracking(item.tracking_no,item.tracking_id,e)}>{item.tracking_no}&nbsp;&nbsp;{copyId === item.tracking_id ? (<span className='text-primary'>Copied!</span>) : (<i className='fas fa-copy'></i>)}</strong>
                </div>

                <div className="col-6 col-lg-4">
                <small className="text-dark d-block">Statement</small>
                <strong className="text-dark">{item.statement_no}</strong>
                </div>

                <div className="col-6 col-lg-4 mt-2">
                <small className="text-dark d-block">{item.label}</small>
                <strong className="text-dark">
                    ${Number(item.amount).toFixed(2)}
                </strong>
                </div>
            </div>
            </button>
        </h2>

        <div
            id={`tracking${item.tracking_id}`}
            className="accordion-collapse collapse"
            data-bs-parent="#detailModalContent"
        >
            <div className="accordion-body bg-light p-3">

            {item?.items?.map((product, i) => (
                <div
                key={i}
                className="border rounded-4 p-3 bg-white mb-3 item-box"
                >
                <div className="row align-items-center">

                    <div className="col-md-2 text-center mb-3 mb-md-0">
                    <img
                        src={`https://erp.makemoneyormiles.com/storage/deals/${product.deal_image}`}
                        className="img-fluid rounded-3 border"
                        style={{ maxHeight: "90px" }}
                        alt={product.deal_name}
                    />
                    </div>

                    <div className="col-md-7">
                    <div className="d-flex align-items-center flex-wrap gap-2 mb-2">
                        <h6 className="mb-0 fw-semibold">
                        {product.deal_name}
                        </h6>
                    </div>

                    <div className="small text-muted">
                        <strong>Model:</strong> {product.model} |{" "}
                        <strong>UPC:</strong> {product.upc} |{" "}
                        <strong>Deal:</strong> {product.deal_no}
                    </div>
                    </div>

                    <div className="col-md-3">
                    <div className="bg-light rounded-4 p-3 small">

                        <div className="d-flex justify-content-between mb-1">
                        <span>Price</span>
                        <strong>
                            ${Number(product.price).toFixed(2)}
                        </strong>
                        </div>

                        <div className="d-flex justify-content-between mb-1">
                        <span>Commission</span>
                        <strong>
                            ${Number(product.commission).toFixed(2)}
                        </strong>
                        </div>

                        <div className="d-flex justify-content-between mb-1">
                        <span>Qty</span>
                        <strong>{product.qty}</strong>
                        </div>

                        <hr className="my-2" />

                        <div className="d-flex justify-content-between align-items-center">
                        <span className="fw-semibold">Total</span>
                        <strong className="text-dark">
                            ${Number(product.total).toFixed(2)}
                        </strong>
                        </div>

                    </div>
                    </div>

                </div>
                </div>
            ))}

            </div>
        </div>
        </div>
    </>
  )
}

export default StatementItem